import { render } from "./bookDetail.vue?vue&type=template&id=a57d82c8&scoped=true"
import script from "./bookDetail.vue?vue&type=script&lang=js"
export * from "./bookDetail.vue?vue&type=script&lang=js"

import "./bookDetail.vue?vue&type=style&index=0&id=a57d82c8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57d82c8"]])

export default __exports__